export interface League {
  key: string;
  name: string;
  en: string;
  region: string;
  cover: string;
}

export const leagues: League[] = [
  {
    key: "premier-league",
    name: "英超",
    en: "Premier League",
    region: "英格兰",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20green%20stadium%20pitch%20with%20spotlights%20and%20soft%20mist%2C%20dark%20emerald%20tones%2C%20sport%20editorial%20poster%20style%2C%20dramatic%20atmosphere%2C%20minimal%20geometric%20lines&width=800&height=500&seq=league-epl-01&orientation=landscape",
  },
  {
    key: "la-liga",
    name: "西甲",
    en: "La Liga",
    region: "西班牙",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20warm%20orange%20stadium%20night%20scene%20with%20light%20beams%20and%20soft%20haze%2C%20sport%20editorial%20poster%20style%2C%20dramatic%20atmosphere%2C%20minimal%20geometric%20lines&width=800&height=500&seq=league-laliga-01&orientation=landscape",
  },
  {
    key: "champions-league",
    name: "欧冠",
    en: "UEFA Champions League",
    region: "欧洲",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20deep%20green%20and%20gold%20stadium%20interior%20with%20light%20rays%2C%20sport%20editorial%20poster%20style%2C%20elegant%20dramatic%20atmosphere%2C%20minimal%20geometric%20lines&width=800&height=500&seq=league-ucl-01&orientation=landscape",
  },
  {
    key: "world-cup",
    name: "世界杯",
    en: "FIFA World Cup",
    region: "国际",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20global%20stadium%20with%20warm%20golden%20spotlights%20and%20confetti%2C%20sport%20editorial%20poster%20style%2C%20festive%20dramatic%20atmosphere%2C%20minimal%20geometric%20lines&width=800&height=500&seq=league-worldcup-01&orientation=landscape",
  },
  {
    key: "csl",
    name: "中超",
    en: "Chinese Super League",
    region: "中国",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20modern%20stadium%20pitch%20with%20evening%20lights%20and%20soft%20fog%2C%20green%20and%20teal%20tones%2C%20sport%20editorial%20poster%20style%2C%20minimal%20geometric%20lines&width=800&height=500&seq=league-csl-01&orientation=landscape",
  },
  {
    key: "serie-a",
    name: "意甲",
    en: "Serie A",
    region: "意大利",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20classic%20stadium%20with%20warm%20amber%20floodlights%20and%20soft%20smoke%2C%20sport%20editorial%20poster%20style%2C%20dramatic%20atmosphere%2C%20minimal%20geometric%20lines&width=800&height=500&seq=league-seriea-01&orientation=landscape",
  },
];